// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1dlP3","col":"styles_col__PgvSw"};